import { Component, OnInit } from '@angular/core';
import { ReservationService } from '../../services/reservation.service';
import { ReservationProductService } from '../../services/reservation-product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonService } from '../../../person/services/person.service';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-reservation',
  templateUrl: './list-reservation.component.html',
  styleUrls: ['./list-reservation.component.css'],
  providers:[ReservationService,PersonService, ReservationProductService]
})
export class ListReservationComponent implements OnInit{
  p: number = 1;
  totalItems: number = 0;
  reservations: any = [];
  reservationProducts: any = [];
  filters:any = {
  };
  filterDni: any;
  filterPersonName: any;
  filterPersonSurname: any;
  filterDate:any;
  filterDueDate:any;
  filterStatus:any;
  exportParams:any ={};
  showExportButton:boolean = true;
  role:number = 3;

  constructor( private route: ActivatedRoute, private router: Router, private reservationService:ReservationService, private personService:PersonService, 
    private reservationProductService:ReservationProductService) { }

  ngOnInit() {
    this.getReservations();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  filterByStatus(){
    if ("Retirada".toLowerCase() == this.filterStatus.toLowerCase()){
      this.filters.status = 2;
    }else if ("Abandonada".toLowerCase() == this.filterStatus.toLowerCase()){
      this.filters.status = 1;
    }else if ("Vigente".toLowerCase() == this.filterStatus.toLowerCase()){
      this.filters.due_date = {};
      this.filters.due_date[">="] = moment().format("YYYY-MM-DD");
      this.filters.status = null;
    }else if ("Fuera de fecha".toLowerCase() == this.filterStatus.toLowerCase()){
      this.filters.due_date = {};
      this.filters.due_date["<"] = moment().format("YYYY-MM-DD");
      this.filters.status = null;
    }else {
      delete this.filters.status;
      delete this.filters.due_date;
    }
    this.getReservations();
  }

  findPerson(){
    delete this.filters.person_id;
    let params:any={}
    if (this.filterDni){
      params.nif = this.filterDni;
    }
    if (this.filterPersonName){
      params.name = this.filterPersonName;
    }
    if (this.filterPersonSurname){
      params.surname = this.filterPersonSurname;
    }
    this.personService.query(params)
    .subscribe((people) => {
        if (people[0] && people[0].id && (this.filterDni || this.filterPersonName || this.filterPersonSurname)){
          this.filters.person_id = people[0].id;
          this.getReservations();
        }else{
          this.getReservations();
        }
    });
  }

  getReservations(){
    if (this.filters.id == ''){
      delete this.filters.id
    }
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.filterDate && moment(this.filterDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.createdAt = params.where.createdAt? params.where.createdAt:{};
      params.where.createdAt[">="] = moment(this.filterDate, "DD-MM-YYYY").format("YYYY-MM-DD 00:00:00");
      params.where.createdAt["<="] = moment(this.filterDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    if (this.filterDueDate && moment(this.filterDueDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.due_date = params.where.due_date? params.where.due_date:{};
      params.where.due_date[">="] = moment(this.filterDueDate, "DD-MM-YYYY").format("YYYY-MM-DD 00:00:00");
      params.where.due_date["<="] = moment(this.filterDueDate, "DD-MM-YYYY").format("YYYY-MM-DD 23:59:59");
    }
    this.exportParams = params;
    this.reservationService.query(params)
      .subscribe((reservations) => {
          this.reservations = reservations;
          this.reservations.forEach((r)=>{
            this.getReservationProducts(r);
          })
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.reservationService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
      });
    
  }

  getReservationProducts(reservation){
    let params = {
      reservation_id : reservation.id
    }
    this.reservationProductService.query(params)
      .subscribe((reservations) => {
        reservations.forEach((r)=>{
          reservation.description = r.labeledproduct.short_description +","
        })
        reservation.description = reservation.description.slice(0, -1);
      });
  }

  getStatusBydate(reservation){
      if (moment(reservation.due_date).format("YYYY-MM-DD") >= moment().format("YYYY-MM-DD")){
          return "Vigente";
      }else{
          return "Fuera de fecha";
      }
  }

  exportReservationsToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Número",
              field2:"Fecha",
              field3:"Fecha Vencimiento",
              field4:"Cliente",
              field5:"Total",
              field6:"Pendiente",
              field7:"Estado",
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableReservationRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100;
        observableReservationRequest.push(this.reservationService.query(this.exportParams));
      }
      Observable.forkJoin(observableReservationRequest)
          .subscribe(data => {
            let p:any = data;
            let reservations = p.flat(); 

            reservations.forEach(reservation =>{
                    var row = {
                        field1:reservation.id?reservation.id:"",
                        field2:reservation.createdAt?moment(reservation.createdAt).format("DD-MM-YYYY"):"",
                        field3:reservation.due_date?moment(reservation.due_date).format("DD-MM-YYYY"):"",
                        field4:reservation.person && reservation.person.name?reservation.person.name:"",
                        field5:reservation.total_amount?reservation.total_amount:"",
                        field6:reservation.total_pending?reservation.total_pending:"",
                        field7:reservation.status == 1?'Abandonada':reservation.status == 2?'Retirada':this.getStatusBydate(reservation),
                    }
                    report.push(row);
                });
                var mystyle = {   
                    headers:true,       
                    columns:    
                        [{columnid:'field1',width:100,title: ''},   
                        {columnid:'field2',width:100,title: ''},
                        {columnid:'field3',width:100,title: 'LISTADO DE RESERVAS'},
                        {columnid:'field4',width:300,title: ''},
                        {columnid:'field5',width:100,title: ''},
                        {columnid:'field6',width:100,title: ''},
                        {columnid:'field7',width:100,title: ''},
                        
                        ],
                    /*header*/
                  
                    column: {  
                        style:{
                            Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",  
                                WrapText:1
                                
                            },
                            Font:{
                                Bold:"1",
                                Color:"#000000",
                                Size:10
                            },
                            
                            Interior:{
                                Color:"#7CEECE",
                                Pattern:"Solid"
                            }
                        }},
                  cells: {    
                        0:{
                            0:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid",
                                        },
                                Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",
                                  WrapText: 1,
                                    },  
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                                },                        
                                }  
                            },
                            1:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                            },  
                                Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },            
                                    }
                            },
                            2:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        }, 
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            }                
                                    }
                                },
                            3:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },            
                                      
                                    }
                                },
                            4:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },
                            5:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                }, 
                            6:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                             
                                }
                                },
                        }   
                  },
            };
            this.showExportButton = true;
            alasql.promise('SELECT * INTO XLSXML("Reservas_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
            .then(function(data){
                console.log('Data saved');
            }).catch(function(err){
                console.log('Error:', err);
            });
        });
  }
  
}


// WEBPACK FOOTER //
// ./src/app/reservation/components/list-reservation/list-reservation.component.ts